// Every current Fulfillment→Proxy hand-off that the backend seed already
// treats as done (material_status "Received Short" or "No Job Found", with
// escalated_to_team set) — see backend/app/data/receiving_log_seed.json and
// demo_fulfillment_seed.py. Those receipts already say the escalation
// happened, so the shared Email Inbox's Fulfillment tab must already show
// the email Ace would have sent at that moment, not start empty and wait for
// someone to re-trigger the live action this session.
//
// Mirrors wayneInboxEmails.ts's convention (pure frontend seed, keyed to a
// real scan/job) — every entry here ties to a real seeded receipt, no orphan
// companies.
export interface FulfillmentEscalation {
  id: string;
  scan: string;
  jobNumber?: string; // absent — no job number was ever found for this scan
  client: string;
  subject: string;
  body: string;
  date: string; // display string, matches WAYNE_INBOX_EMAILS's date convention
}

export const FULFILLMENT_ESCALATIONS: FulfillmentEscalation[] = [
  // ── Received Short — auto-escalated to Cary for shortage followup ──
  {
    id: 'S-P10', scan: 'S-P10', jobNumber: '3060010', client: 'Ballston Spa Bancorp',
    subject: 'Escalated to Proxy/ICT - Scan S-P10',
    body: 'Received short: 5 of 6 Notice/Proxy Statement copies received (short 1). Auto-escalated to Proxy/ICT for shortage followup.',
    date: 'Today · 8:50 AM',
  },
  {
    id: 'S-P11', scan: 'S-P11', jobNumber: '3060011', client: 'Phas Tech Holding Ltd',
    subject: 'Escalated to Proxy/ICT - Scan S-P11',
    body: 'Received short: 3 of 5 Notice/Proxy Statement copies received (short 2). Auto-escalated to Proxy/ICT for shortage followup.',
    date: 'Today · 8:20 AM',
  },
  {
    id: 'S-P320', scan: 'S-P320', jobNumber: '4010009', client: 'Kestrel Transit Authority',
    subject: 'Escalated to Proxy/ICT - Scan S-P320',
    body: 'Received short: 4 of 6 Notice/Proxy Statement copies received (short 2). Auto-escalated to Proxy/ICT for shortage followup.',
    date: 'Today · 7:40 AM',
  },
  {
    id: 'S-P321', scan: 'S-P321', jobNumber: '4010010', client: 'Bellcrest Retail Holdings',
    subject: 'Escalated to Proxy/ICT - Scan S-P321',
    body: 'Received short: 2 of 5 Notice/Proxy Statement copies received (short 3). Auto-escalated to Proxy/ICT for shortage followup.',
    date: 'Yesterday · 4:05 PM',
  },
  {
    id: 'S-P322', scan: 'S-P322', jobNumber: '4010011', client: 'Northstar Agri Corp',
    subject: 'Escalated to Proxy/ICT - Scan S-P322',
    body: 'Received short: 1 of 3 Notice/Proxy Statement copies received (short 2). Auto-escalated to Proxy/ICT for shortage followup.',
    date: 'Yesterday · 2:30 PM',
  },
  {
    id: 'S-P326', scan: 'S-P326', jobNumber: '4010015', client: 'Thackeray Grain Cooperative',
    subject: 'Escalated to Proxy/ICT - Scan S-P326',
    body: 'Received short: 2 of 4 Notice/Proxy Statement copies received (short 2). Auto-escalated to Proxy/ICT for shortage followup.',
    date: 'Today · 6:55 AM',
  },
  {
    id: 'S-P327', scan: 'S-P327', jobNumber: '4010016', client: 'Cormorant Energy Partners',
    subject: 'Escalated to Proxy/ICT - Scan S-P327',
    body: 'Received short: 4 of 7 Notice/Proxy Statement copies received (short 3). Auto-escalated to Proxy/ICT for shortage followup.',
    date: 'Yesterday · 5:15 PM',
  },
  // ── No Job Found — escalated to Cary for manual job matching ──
  {
    id: 'S-P317', scan: 'S-P317', client: 'Hallowell Shipping Corp',
    subject: 'Escalated to Proxy/ICT - Scan S-P317',
    body: "Can't find a job number for this material because the client name doesn't match any open job. Escalated to Proxy/ICT for manual matching.",
    date: 'Yesterday · 11:15 AM',
  },
  {
    id: 'S-P318', scan: 'S-P318', client: 'Redgate Financial Group',
    subject: 'Escalated to Proxy/ICT - Scan S-P318',
    body: "Can't find a job number for this material because the client name doesn't match any open job. Escalated to Proxy/ICT for manual matching.",
    date: '2 days ago · 3:50 PM',
  },
];
